import { RecordCreate } from "@pdfking/tfunc"

import type { CacheBackend } from "#public"

export const MemoryStore = <V>(): CacheBackend<V> => {
  const cache = new Map<string, V>()

  return {
    clear: async () => cache.clear(),
    delete: async (key: string) => void cache.delete(key),
    exists: async (key: string) => cache.has(key),
    get: async (key: string) => cache.get(key),
    list: async () => RecordCreate(cache.entries()),
    set: async (key: string, value: V) => void cache.set(key, value),
  }
}
